import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import {
  getBookingServiceProperties,
  setModal,
  postNotification,
  getBookingServiceProperty,
} from '../../../../../../../../../data/actions'
import { selectCurrentBookingServiceProperties } from '../../../../../../../../../data/selectors/tenantBookings'
const BookingProperties = ({
  getBookingServiceProperty,
  getBookingServiceProperties,
  setModal,
  service,
  booking,
  serviceProperties,
  postNotification,
  isEditable,
}) => {
  useEffect(() => {
    getBookingServiceProperties(booking, service)
  }, [])
  return serviceProperties.length ? (
    <table className="wb-table wb-table--striped">
      <thead>
        <tr>
          <th scope="col">Name</th>
          <th scope="col">Slug</th>
          <th scope="col">Type</th>
          <th scope="col">Required</th>
          <th scope="col">Used Default</th>
          <th scope="col">Value</th>
        </tr>
      </thead>
      <tbody>
        {serviceProperties.map((property) => (
          <tr key={property.slug}>
            <th scope="row">{property.name}</th>
            <td>{property.slug}</td>
            <td>{property.type}</td>
            <td>
              {property.required ? (
                <wb-icon
                  name="bds/checkmark-circle/24"
                  aria-hidden="true"
                  class="wb-button__icon"
                  fill="red"
                />
              ) : null}
            </td>
            <td>
              {property.defaultUneditedValue ? (
                <wb-icon
                  name="bds/checkmark-circle/24"
                  aria-hidden="true"
                  class="wb-button__icon"
                  fill="red"
                />
              ) : null}
            </td>
            <td>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <span>{property.value}</span>
                <div>
                  <button
                    type="button"
                    aria-label="Close Button"
                    className="wb-round-button wb-round-button--small"
                    onClick={() => {
                      navigator.clipboard.writeText(
                        `https://${process.env.TENANTS_API_HOST}/tdms/v1/platformServiceProperties/platformBooking/${booking.id}/${service.slug}/${property.slug}`,
                      )
                      postNotification({
                        message: 'The link was copied successfully',
                      })
                    }}
                  >
                    <wb-icon
                      className="wb-round-button__icon"
                      aria-hidden="true"
                      name="bds/link/24"
                    ></wb-icon>
                    Copy
                  </button>
                  {isEditable ? (
                    <button
                      type="button"
                      aria-label="Close Button"
                      className="wb-round-button wb-round-button--small"
                      onClick={() =>
                        getBookingServiceProperty(
                          booking.id,
                          service.slug,
                          property,
                          () => {
                            setModal({
                              variant: 'bookingServiceProperty',
                              mode: 'edit',
                              bookingId: booking.id,
                              bookingSlug: booking.packageDisplayName,
                              serviceSlug: service.slug,
                            })
                          },
                        )
                      }
                    >
                      <wb-icon
                        className="wb-round-button__icon"
                        aria-hidden="true"
                        name="bds/pencil/24"
                      ></wb-icon>
                      Edit
                    </button>
                  ) : null}
                </div>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <div>No Properties found for selected service</div>
  )
}

export default connect(
  (
    { tenantBookings: { properties }, tenants: { isWhitelisted, isAlmighty } },
    ownProps,
  ) => ({
    serviceProperties: selectCurrentBookingServiceProperties(
      ownProps.booking.id,
      ownProps.service.slug,
      properties,
    ),
    isEditable: isWhitelisted || isAlmighty,
  }),
  {
    getBookingServiceProperties,
    setModal,
    postNotification,
    getBookingServiceProperty,
  },
)(BookingProperties)
